import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { CloseIcon } from '../../../../Icons';
import withDelayedHovering from '../../../components/Utils/withDelayedHovering';
import { getColorClassName } from '../utils/colors';

var Tag = function Tag(_ref) {
  var option = _ref.option,
      _ref$onRemove = _ref.onRemove,
      onRemove = _ref$onRemove === void 0 ? function () {
    return true;
  } : _ref$onRemove,
      _ref$hovering = _ref.hovering,
      hovering = _ref$hovering === void 0 ? false : _ref$hovering,
      _ref$preventRemoval = _ref.preventRemoval,
      preventRemoval = _ref$preventRemoval === void 0 ? false : _ref$preventRemoval;
  // to make dark mode work, we go from hard coded hexa to classnames.
  var tagColorClassName = getColorClassName({
    bgColor: option.bgColor
  });
  return React.createElement("div", {
    className: classNames('flexbox flexbox-align-center nowrap', 'font-weight-medium', 'radius-largest transition', tagColorClassName, hovering && !preventRemoval ? 'padding-horizontal-small' : 'padding-horizontal-medium')
  }, option.label, !preventRemoval && React.createElement("div", {
    className: "overflow-hidden transition flexbox flexbox-align-center pointer",
    onClick: onRemove,
    style: {
      width: hovering ? 16 : 0,
      height: 16,
      paddingLeft: hovering ? 4 : 0,
      paddingRight: hovering ? 4 : 0
    }
  }, React.createElement(CloseIcon, {
    size: 8
  })));
};

Tag.propTypes = {
  option: PropTypes.object.isRequired,
  isActive: PropTypes.bool,
  onRemove: PropTypes.func,
  hovering: PropTypes.bool,
  preventRemoval: PropTypes.bool
};
export default withDelayedHovering(Tag);